import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import { ClearwaterTransactionsPanelModule } from '@helios/panels/clearwater-transactions'
import {
  ExternalTransactionsPanelComponent,
  ExternalTransactionsPanelModule,
} from '@helios/panels/external-transactions'
import { TransactionsPanelComponent } from './transactions-panel.component'

@NgModule({
  imports: [
    CommonModule,
    ExternalTransactionsPanelModule,
    ClearwaterTransactionsPanelModule,
    GenericComponentsModule,
    ResizeHandleModule,
  ],
  declarations: [TransactionsPanelComponent],
  exports: [TransactionsPanelComponent],
  providers: [ExternalTransactionsPanelComponent],
})
export class TransactionsModule {}

export { TransactionsPanelComponent }
